<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-row>
          <v-col
            :lg="6"
            :md="6"
            :sm="6"
            :xs="12"
          >
            <v-form
              ref="form"
              lazy-validation
              class="app-form"
              @submit.prevent="onSubmit"
            >
              <v-card
                class="app-card"
                elevation="0"
              >
                <v-card-title class="app-card-title">
                  <h4 class="text">
                    <span>{{ !isEditableRouter() ? 'Novo' : 'Editar' }} Perfil</span>
                  </h4>
                </v-card-title>
                
                <v-card-text class="app-card-content">
                  <v-text-field
                    v-model="profile.data.name"
                    :rules="[rules.required]"
                    label="Nome Perfil *"
                    placeholder="Ex:. Administrador"
                    outlined
                    dense
                  />
              
                  <v-text-field
                    v-model="profile.data.key"
                    :rules="[rules.required]"
                    label="Key *"
                    placeholder="Ex:. ADMIN"
                    outlined
                    dense
                    :disabled="isEditableRouter()"
                  />                
                </v-card-text>
                    
                <v-divider />

                <v-card-actions class="app-card-actions">
                  <span class="app-form__warning">
                    Atenção: Campos que possuem o
                    <em>*</em> são obrigatórios
                  </span>
                  <v-spacer />
                  <v-btn
                    depressed
                    outlined
                    color="error"
                    @click="$router.back()"
                  >
                    Voltar
                  </v-btn>
                  <v-btn
                    depressed
                    color="success"
                    type="submit"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>

                <section
                  v-if="profile.isLoading"
                  class="loading"
                >
                  <v-progress-circular
                    indeterminate
                    color="success"
                  />
                  <span>Enviando informações ...</span>
                </section>
              </v-card>
            </v-form>
          </v-col>

          <v-col
            :lg="6"
            :md="6"
            :sm="6"
            :xs="12"
          >                     
            <ProfileFunctionalityList 
              v-if="profile.data.id"
              :profile-id="profile.data.id" 
            />            
          </v-col>
        </v-row>                   
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ProfileFunctionalityList from './components/ProfileFunctionalityList.vue';

  export default {
    components: {
      ProfileFunctionalityList      
    },

    data: () => ({  
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },         
    }),

    computed: {
      ...mapState('perfil', {
        profile: state => state.detail
      }),
    },

    watch: {
      '$route.params.id'(newId, oldId) {      
        this.fetchProfile();
      }
    },
    
    mounted() {      
      this.fetchProfile();   
    },
    
    destroyed() {      
      this.clear();
    },

    methods: {
      fetchProfile() {
        if (!this.$route.params.id) return;

        this.show(this.$route.params.id);
      },

      onSubmit() {
        const isValid = this.$refs.form.validate();

        if (isValid) {
          if (this.isEditableRouter()) {
            this.update(this.profile.data);
          } else {
            this.create(this.profile.data);
          }
        }
      },

      isEditableRouter() {
        return this.$route.name === 'dashboard-perfis-editar';
      },

      ...mapActions('perfil', { show: 'SHOW' }),
      ...mapActions('perfil', { clear: 'CLEAR_DETAIL' }),
      ...mapActions('perfil', { create: 'CREATE' }),
      ...mapActions('perfil', { update: 'UPDATE' })
    },
  };
</script>

<style lang="scss" scoped>
.title {
  margin: 0px;
  font-size: 15px !important;
  font-weight: bold !important;
}
</style>

